/**
 * masonry
 *
 * @plugin  masonry
 * @link    http://masonry.desandro.com/
 */

+function ($) {
	'use strict';
    
    document.addEventListener('load', (function(){
        var onLoad = function(){
            $('#js-gallery').masonry({
                itemSelector: '.gallery__item',
                columnWidth: '.masonry-grid',
                gutter: '.masonry-gutter',
                percentPosition: true
            });
        };
        return function(e){
            $(e.target).filter('#js-gallery .gallery__src').each(onLoad);
        };
    })(), true);


}(jQuery);